// ---------------------------------------------------------------------------
// Permanent (301) redirect map: old Google-indexed voiceoverkids.nl URLs ->
// new canonical URLs on the rebuilt site. Keys are stored WITHOUT a trailing
// slash; the router matches the trailing-slash variant automatically. This
// same map is mirrored in /public/_redirects and /public/serve.json for true
// server-side 301s at the hosting/CDN layer.
// ---------------------------------------------------------------------------

export const LEGACY_REDIRECTS = {
  // Company / info pages
  "/over_kinderstemmen_voiceoverkids": "/about",
  "/kinderstemmen_opname_studio": "/studio",
  "/kinderstemmen-casting-agency-referenties": "/work",
  "/kinderstemmen_boeken_contact": "/contact",
  "/kinderstemmen_ai_artificial_intelligence": "/ai-voices",
  "/text_naar_spraak_kinderstemmen_voor_nederlandse_kinderen": "/ai-voices",

  // Language pages -> /kinderstemmen/<taal>
  "/kinderstemmen_stemmenbank/kinderstemmen_nederlands_voiceoverkids": "/kinderstemmen/nederlands",
  "/kinderstemmen_amerikaans_engels": "/kinderstemmen/amerikaans-engels",
  "/kinderstemmen_brits_engels": "/kinderstemmen/brits-engels",
  "/kinderstemmen_australisch_engels": "/kinderstemmen/australisch-engels",
  "/kinderstemmen_duits": "/kinderstemmen/duits",
  "/kinderstemmen-frans": "/kinderstemmen/frans",
  "/kinderstemmen_spaans_spanje_espagnol": "/kinderstemmen/spaans",
  "/kinderstemmen_italiaans_italie": "/kinderstemmen/italiaans",
  "/kinderstemmen_belgie_vlaams": "/kinderstemmen/belgisch-vlaams",
  "/kinderstemmen_deens_denemarken_dansk": "/kinderstemmen/deens",
  "/kinderstemmen_noors_noorwegen": "/kinderstemmen/noors",
  "/kinderstemmen_zweeds_zweden": "/kinderstemmen/zweeds",
  "/kinderstemmen_fins_finland": "/kinderstemmen/fins",
  "/kinderstemmen_portugees_portugal": "/kinderstemmen/portugees-portugal",
  "/kinderstemmen_griekenland_grieks": "/kinderstemmen/grieks",
  "/kinderstemmen_polen_pools_poland": "/kinderstemmen/pools",
  "/kinderstemmen_roemenie_roemeens": "/kinderstemmen/roemeens",
  "/kinderstemmen_turks_turkije": "/kinderstemmen/turks",
  "/kinderstemmen_rusland_russische_federatie": "/kinderstemmen/russisch",
  "/kinderstemmen_arabisch_midden_oosten": "/kinderstemmen/arabisch",
  "/kinderstemmen_hebreeuws_israelisch": "/kinderstemmen/hebreeuws",
  "/kinderstemmen_chinees_china": "/kinderstemmen/chinees",
  "/kinderstemmen_japan_japans": "/kinderstemmen/japans",
  "/kinderstemmen_vietnamees_vietnam": "/kinderstemmen/vietnamees",
  "/kinderstemmen-afrikaans-zuid-afrika": "/kinderstemmen/afrikaans",
  "/kinderstemmen_zuid_amerika-latin-spaans": "/kinderstemmen/latijns-amerikaans-spaans",

  // Discontinued pages (no dedicated equivalent) -> sensible parent, never a 404
  "/kinderstemmen_europees_mid-atlantic_engels": "/kinderstemmen",
  "/kinderstemmen_india_hindi_marathi_kannada": "/kinderstemmen",
  "/kinderstemmen_zang_stemmen_kinderkoor": "/kinderstemmen",
  "/kinderstemmen_nieuws": "/",
  "/blog": "/",
};
